import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/random-team-stacking/actions';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

class ForceCaptain extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.set('CaptainIsForced', isChecked));
    }

    render() {
        const {stacking, modesConfig} = this.props;
        const isChecked = stacking.isCaptainForced();
        const cptConfig = modesConfig.getConfig('CPT');

        return (
            <InputCheckbox
                label={`Force ${cptConfig.getLabel()} to the first stack`}
                value="1"
                checked={isChecked}
                onChange={::this.onChange}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {randomTeamStacking, modesConfig} = state;
    return {
        stacking: randomTeamStacking,
        modesConfig,
    };
}

export default connect(mapStatesToProps)(ForceCaptain);
